import { gql } from 'graphql-tag'
import { addressFields } from '../addressFields'

/**
 * CMA-scoped order fragment — fields the mobile app actually reads.
 *
 * Derived from the shared superset in `../orderFields` by dropping the eleven
 * CWA-only fields confirmed unused by the CMA app at the time of extraction:
 *   originalAddress, addressId (top-level), addressCorrectionAllowed,
 *   instructionEditsAllowed, hasInstructions, hasCode, hasApartment,
 *   isOrderReroutable, packages.requiresSignatureByPin, packages.pin,
 *   packages.consumerSupportCase.
 *
 * `alert` is kept: CMA reads it in OrderSummary (order.alert).
 */
export const orderFieldsCMA = gql`
  fragment OrderFieldsCMA on Order {
    alert {
      title
      body
    }
    address {
      ...AddressFields
    }
    authedUserOwnsOrder
    clientId
    clientName
    clientDisplayName
    merchantName
    consumerId
    calculatedOrderInformation {
      orderStatus
      orderDeliveryDates
      isDeliveryByEvening
    }
    calculatedPackagesInformation {
      deliveredPackages {
        groupedByDeliveredAtTime {
          deliveredAt
          trackingIds
        }
        total
      }
      notDeliveredPackages {
        groupedByDeliveryDate {
          deliveryDate
          trackingIds
        }
        groupedByDeliveryWindow {
          endsAt
          startsAt
          trackingIds
        }
        groupedByEveningPackages
        groupedByMissingDeliveryDate
        total
      }
      pickedUpPackages {
        groupedByPickedUpAtTime {
          pickedUpAt
          trackingIds
        }
        total
      }
      notPickedUpPackages {
        groupedByPickUpDate {
          pickUpDate
          trackingIds
        }
        groupedByPickUpWindow {
          endsAt
          startsAt
          trackingIds
        }
        groupedByEveningPackages
        groupedByMissingPickUpDate
        total
      }
      totalPackages
    }
    deliveryDate
    deliveryDateInfo {
      date
      dateType
      hasBeenUpdated
    }
    deliveryTimeWindow {
      startsAt
      endsAt
    }
    facilityId
    instructions
    isEditable
    isOrderReroutableByConsumer
    isPastConsumerRerouteCutoff
    orderId
    packages {
      deliveryTimeWindow {
        endsAt
        startsAt
      }
      eventLog {
        operation
        timestamp
        message
        meta
        facility {
          facilityId
          city
          state
        }
      }
      packageId
      trackingId
      scheduledServiceDate
      timeZone
    }
    reroutableZipCodes
    rerouteBlockedByClient
    serviceType
    timeZone
  }
  ${addressFields}
`
